import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** The clients section: the list, one client's page, the blocked numbers. One guard for all. */
export const Route = createFileRoute("/_app/clients")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "clients");
  },
  component: Outlet,
});
